










































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import Vue, { PropType } from "vue";

import RestClient, { RestError } from "../../RestClient";
import DemoServer from "../../shared/DemoServer";
import DateFormatter from "../../shared/DateFormatter";
import PointerMenu from "./PointerMenu.vue";
import ExpandableView from "../controls/ExpandableView.vue";
import Loading from "./Loading.vue";

import CustomInputInput from "../general/CustomInputInput.vue";
import CustomInputView from "../controls/CustomInputView.vue";

import { Gender, GenderNames } from "../../shared/Gender";
import ContactJson from "../../shared/ContactJson";
import { CustomInputCategory, CustomInputCategoryNames } from "../../shared/CustomInputCategory";

import { UserPermissionRank } from "../../shared/UserPermissionRank";
import UserPermissionTypeInfoJson from "../../shared/UserPermissionTypeInfoJson";

export default Vue.extend({
  name: "FormContact",
  components: {
    PointerMenu,
    ExpandableView,
    Loading,
    CustomInputInput,
    CustomInputView,
  },
  props: {
    restClient: RestClient,
    loginId: Number,
    loginPermission: Number,
    data: Object,
    editable: Boolean,
    isCustomerInfo: {
      type: Boolean,
      default: false,
    },
    hideInputs: {
      type: Array,
      default() {
        return [];
      },
    },
    requiredInputs: {
      type: Array,
      default() {
        return [];
      },
    },
    customId: {
      default: "0",
    },
    validation: Object,
    submitValidation: Boolean,
  },
  data() {
    return {
      DemoServer: DemoServer,
      DateFormatter: DateFormatter,
      //supportsDatePicker: false,
      UserPermissionRank: UserPermissionRank,
      Gender: Gender,
      GenderNames: GenderNames,
      CustomInputCategory: CustomInputCategory,
      CustomInputCategoryNames: CustomInputCategoryNames,
      details: null as ContactJson | null,
      //cachedBirthDate: "" as string,
      toValidate: {} as any,
      loadingGeneral: false as boolean,
    };
  },
  created() {
    this.init();
  },
  mounted() {
    //this.checkDatePickerSupport();
    //this.setCachedBirthDate();
  },
  methods: {
    //removed cachedBithDate for browsers without datepicker

    init() {
      this.details = this.data;
    },

    blur() {
      this.$emit("blur", this.details);
    },

    /* checkDatePickerSupport() {
      let testvalue = "a";
      var ele = <HTMLInputElement>this.$refs["testDatePicker"];

      if (ele != null) {
        ele.value = testvalue;

        if (ele.value !== testvalue) {
          this.supportsDatePicker = true;
        }
      }
    }, */

    //START set cached data

    /* setCachedBirthDate() {
      if (this.details != null) {
        if (this.supportsDatePicker) {
          this.cachedBirthDate = this.details.birthDate!;
        } else {
          let d = new Date(this.details.birthDate!);

          if (d != null) {
            this.cachedBirthDate = DateFormatter.formatDateMedium(d);
          }
        }
      }
    }, */

    //END set cached data

    inputValidation(key: any, prop: any) {
      if (prop) {
        if (!(key in this.toValidate)) {
          this.toValidate[key] = {};
        }
        this.toValidate[key][prop] = true;
      } else {
        this.toValidate[key] = true;
      }

      this.$emit("validateInput", "generalCustomer", key);

      this.$forceUpdate();
    },

    removeValidationHint(key: any, prop: any) {
      if (key in this.toValidate) {
        if (prop) {
          delete this.toValidate[key][prop];
        } else {
          delete this.toValidate[key];
        }
      }

      this.$forceUpdate();
    },

    frontendValidation() {
      this.$emit("frontendValidation");
    },

    //START set input data (where data be cached)

    /* setBirthDate() {
      if (this.details != null) {
        var birthDate = "";

        if (this.supportsDatePicker) {
          birthDate = this.cachedBirthDate;
        } else {
          if (this.cachedBirthDate.match(/^\d{1,2}.\d{1,2}.\d{4}$/g)) {
            let d = DateFormatter.parseDateString(this.cachedBirthDate);

            if (d != null) {
              birthDate = DateFormatter.formatISODate(d);
            }
          }
        }

        this.details.birthDate = birthDate != "" ? birthDate : null;
      }
    }, */

    //END set input data (where data be cached)

    checkHideInput(inputs: string[]): boolean {
      const vue = this;

      function isKeyOfContact(key: PropertyKey): key is keyof ContactJson {
        let keys: ContactJson = vue.details as ContactJson;
        return key in keys;
      }

      if (!inputs.some((i) => !this.hideInputs.includes(i))) {
        return true;
      }

      if (this.editable) {
        return false;
      }

      if (!inputs.some((i) => this.details && isKeyOfContact(i))) {
        return false;
      }

      if (!inputs.some((i) => this.details && isKeyOfContact(i) && this.details[i] != null)) {
        return true;
      }

      if (!inputs.some((i) => this.details && isKeyOfContact(i) && this.details[i] != "")) {
        return true;
      }

      return false;
    },

    getFormatPrice(price: number) {
      return price
        .toString()
        .padStart(3, "0")
        .replace(/(\d{2,2})$/g, ",$1")
        .replace("NaN", "");
    },
  },

  watch: {
    data: function () {
      this.details = this.data;
    },

    details: {
      handler(val, oldVal) {
        this.$emit("change", this.details);
      },
      deep: true,
    },

    /* submitValidation: function () {
      if (this.submitValidation) {
        if (this.details != null) {
          this.validation = validateSepaMandate(this.details);
        }
      }
    }, */
  },

  computed: {
    permissionAble: function () {
      if (this.loginPermission >= this.UserPermissionRank.management) {
        return true;
      } else {
        return false;
      }
    },
  },
});
